<template>
  <div>
    <template v-if="fvp.length==0">
      <div class="favorite_no_data">
        <p class="first_msg">現在「お気に入り求人」に保存された情報はありません。</p>
        <p>検索結果一覧や求人詳細の「お気に入りに保存」ボタンから保存することができます。</p>
      </div>
    </template>

    <template v-else>
      <table class="favorite_table">
        <tbody>
          <tr>
            <th class="vacancyName" scope="col">求人名</th>
            <th class="sp_hidden" scope="col">給与</th>
            <th class="sp_hidden workingPlace" scope="col">勤務地</th>
            <th class="sp_hidden" scope="col">交通機関</th>
            <th class="sp_hidden" scope="col">勤務時間時間</th>
            <th class="sp_hidden" scope="col">休日</th>
            <th scope="col"></th>
          </tr>
          <tr v-for="fp in fvp">
            <td><a v-bind:href="detailHrefPrefix + fp.position_cd" target="_blank">{{ fp.catchcopy }}</a></td>
            <td class="sp_hidden">{{ fp.salaries_and_allowances }}</td>
            <td class="sp_hidden">{{ `${fp.prefecture_name} ${fp.city_name}` }}</td>
            <td class="sp_hidden">{{ fp.transportation_facilities }}</td>
            <td class="sp_hidden">{{ fp.working_hours }}</td>
            <td class="sp_hidden">{{ fp.holidays_and_vacation }}</td>
            <td class="favorite_table_btn">
              <div class="btn_resister">
                <a v-bind:href="detailHrefPrefix + fp.position_cd + detailHrefSuffix">
                  <img v-bind:src="imgListRegister" alt=""/>
                </a>
              </div>
              <div class="btn_delete">
                <a href="#" ><img v-bind:src="imgDeleteBtn" alt="" v-on:click.stop="clickBttn($event)"/></a>
                <span v-bind:data-id="fp.id" class="js-remove-favorite"></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <div class='total_txt favorite'>計<span>{{ fvp.length }}</span>件</div>

    <div class='attention'>
      <div class="attention_ttl"><img v-bind:src="imgAttention" alt=""><span class="span_txt">ご注意点</span></div>
      <ul class='attention_cont'>
        <li><i class='fa fa-circle'/>お気に入りに登録できる求人数は最大{{ listMaxNum }}件です。</li>
        <li><i class='fa fa-circle'/>{{ listMaxNum }}件を超えた場合は、登録の古い順に自動的に「お気に入り求人」から削除されます。</li>
        <li><i class='fa fa-circle'/>掲載終了した求人は自動的に「お気に入り求人」から削除されます。</li>
      </ul>
    </div>

  </div>
</template>

<script>
  import $ from 'jquery';

  export default {
    props: {
      favorite_positions: { require: true, type: Array },
    },
    emits: ['remove-fp'],
    data: function () {
      return {
        detailHrefPrefix: "",
        detailHrefSuffix: "",
        imgListRegister: "",
        imgDeleteBtn: "",
        imgAttention: "",
        listMaxNum: 0,
      }
    },
    mounted: function() {
      this.detailHrefPrefix = '/search/result_detail/'
      this.detailHrefSuffix = '#PhSlideBox'
      this.imgListRegister = '/img/application/btn_list_register_off.gif'
      this.imgDeleteBtn = '/img/application/btn_list_delete_off.gif'
      this.imgAttention = '/img/application/i_attention_ttl.png'
      this.listMaxNum = 80
    },
    computed: {
      fvp(){ return this.favorite_positions }
    },
    methods: {
      clickBttn(event){
        let dataId = $(event.target).closest('div').find('span')[0].getAttribute('data-id') // vueのclickEventからJqueryObject作成
        $(event.target).closest('div').find('span').trigger('click') // right_areaへの伝播(vueJsでは広範囲の改修をする必要あり)
        this.$emit('remove-fp', dataId) // このVueComponentのリスト対応
      }
    }
  }
</script>
